import * as types from "../../../actions/actionTypes";
const initialState = {
  loading: true,
  processing: false,
  data: {
    data: [],
    meta: {},
    page_payment_sum: 0,
    page_receive_sum: 0,
    total_payment_sum: 0,
    total_receive_sum: 0,
    total_remain: 0,
    use_remain: false
  }
};

const ManagerHashtagDetailReport = (state = initialState, action) => {
  switch (action.type) {
    case types.MANAGER_GET_HASHTAG_DETAIL_REVIEW_REQUEST:
      return { ...state, loading: true };
    case types.MANAGER_GET_HASHTAG_DETAIL_REVIEW_SUCCESS:
      return { ...state, loading: false, data: action.payLoad };
    case types.MANAGER_GET_HASHTAG_DETAIL_REVIEW_FAILURE:
      return { ...state, loading: false };

    default:
      return state;
  }
};

export default ManagerHashtagDetailReport;
